import { render } from "./AddWorker.vue?vue&type=template&id=554fc8f2"
import script from "./AddWorker.vue?vue&type=script&lang=js"
export * from "./AddWorker.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\estimate\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__